import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { api } from "../../lib/api";
import { useLanguage } from "../../contexts/LanguageContext";

export default function Testimonials({ network }) {
  const [reviews, setReviews] = useState([]);
  const { t, field } = useLanguage();

  useEffect(() => {
    api.get("/reviews", { params: network ? { network } : {} }).then(({ data }) => setReviews(data)).catch(() => {});
  }, [network]);

  if (!reviews.length) return null;

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8" data-testid="testimonials-section">
      <div className="mx-auto max-w-6xl">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-12 text-center">{t("home.testimonials_title", "Ils nous font confiance")}</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {reviews.map((r, i) => {
            return (
              <motion.div key={r.id} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                className="rounded-2xl border border-white/5 bg-zinc-900/60 p-6" data-testid={`review-card-${r.id}`}>
                <div className="flex items-center justify-between mb-3">
                  <div className="flex gap-0.5">
                    {Array.from({ length: r.rating }).map((_, idx) => <Star key={idx} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />)}
                  </div>
                  {r.network_slug && (
                    <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-white/5 text-zinc-400 capitalize" data-testid={`review-network-badge-${r.id}`}>{r.network_slug}</span>
                  )}
                </div>
                <p className="text-sm text-zinc-300 mb-4">"{field(r, "comment")}"</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-white">{r.author_name}</span>
                  {r.created_at && <span className="text-[11px] text-zinc-500" data-testid={`review-date-${r.id}`}>{new Date(r.created_at).toLocaleDateString(t("common.locale", "fr-FR"))}</span>}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
